import type {ColorStorage} from '@Components/color-picker-v2';
import type {RGBA} from '@Utils/color.util';
import {getAssetUrl} from '@Utils/s3.util';
import {isWebpSupported} from '@Utils/browser.util';

const MIXED_COLOR_SWATCH_THUMB_NAME = 'mixed-color-swatch-thumb';

/** Background size that pushes the mixed thumbnail's own outline and rounded corners outside the swatch. */
export const MIXED_COLOR_SWATCH_THUMB_SCALE = '130%';

/**
 * Resolves the swatch thumbnail shown when the selected items have different colours, preferring the
 * webp asset where the browser supports it and falling back to the png otherwise. Used by ColorFill
 * to render its "mixed colours" state; callers pass the `isColorMixed` boolean rather than this URL.
 */
export function getMixedColorSwatchThumbUrl(): string {
  return getAssetUrl(`${MIXED_COLOR_SWATCH_THUMB_NAME}.${isWebpSupported() ? 'webp' : 'png'}`);
}

/**
 * Maps picker colour stops to the `color` prop ColorFill expects: a single colour for one stop, otherwise the
 * stops reversed, because ColorFill paints a gradient from its second entry to its first.
 */
export function getColorFillColors(colors: ColorStorage[]): RGBA | RGBA[] {
  if (colors.length === 1) {
    return colors[0].color;
  }
  return colors
    .map((colorStorage) => {
      return colorStorage.color;
    })
    .reverse();
}
